<template>
  <el-drawer
    v-if="visible"
    visible
    :title="$l('dialog_title_update_sku') || '修改SKU'"
    show-close
    :size="1000"
    :before-close="() => $refs.main.cancel()"
  >
    <div class="drawer-main">
      <Main
        ref="main"
        @reload="$emit('reload')"
        @close="close()"
        :disabled="disabled"
        :platformCode="platformCode"
        :hxSkuPlatformCode="hxSkuPlatformCode"
      />
    </div>
    <div class="drawer-footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        v-if="!disabled"
        type="primary"
        size="small"
        @click="$refs.main.save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    platformCode: { type: String, default: '' },
    hxSkuPlatformCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
